module.exports = __webpack_public_path__ + "img/20190522102536微信截图_20190522102905.956d27e5.png";